// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCopyText, iconCopyTextTag } from '@ni/nimble-components/dist/esm/icons/copy-text';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCopyText };
export { iconCopyTextTag };
export const NimbleIconCopyText = wrap(IconCopyText);